<div id="latam-it-loader" class="loader" [class.loader-hidden]="!show">
  <div class="loading">
    <voxel-loading *ngIf="show"></voxel-loading>
  </div>
</div>
